module.exports = __webpack_public_path__ + "static/media/activity.58fcdb84.gif";